import { motion } from 'framer-motion';
import CarList from './CarList';

const Hero = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <div className="relative">
        {/* Pozadí s překryvem */}
        <div 
          className="absolute inset-0 bg-cover bg-center z-0"
          
        />
        
        {/* Hlavní obsah */}
        <div className="relative z-10 container mx-auto px-4 py-24">
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-6xl font-bold text-white mb-6 bg-gradient-to-r from-blue-500 to-purple-600 bg-clip-text text-transparent">
              Vstupte do světa amerických aut s AMA-Europe!
            </h1>
            <p className="text-xl text-gray-300 mb-12 leading-relaxed">
              Hledáte spolehlivý a cenově výhodný způsob, jak získat svůj vysněný vůz? 
              Naše aukční platforma, specializující se na americká auta, vám nabízí živé aukce, 
              transparentní informace díky přístupu k Carfaxu a možnost osobní prohlídky každého vozu.
            </p>
            <div className="flex justify-center gap-6">
              <button className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg 
                               transition-all duration-300 transform hover:scale-105">
                Prozkoumat nabídku
              </button>
              <button className="px-8 py-3 bg-purple-600 hover:bg-purple-700 text-white rounded-lg 
                               transition-all duration-300 transform hover:scale-105">
                Jak to funguje
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;